import React, { useEffect, useState, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { SubjectDataContext } from "./SubjectRoot";
import { IoMdArrowRoundBack } from "react-icons/io";
import { TrialInformationTable } from "../components/Tables/TrialInformationTable";
import { MetricsTable } from "../components/Tables/MetricsTable";
import Global from "../utils/Global";

export default function ChartTrials() {
  const [dataReady, setDataReady] = useState(false);
  const [trial, setTrial] = useState(null);
  const { trialId } = useParams(); // Get trialId from URL params
  const navigate = useNavigate();

  // Get data from context instead of fetching separately
  const contextValue = useContext(SubjectDataContext);
  const subject = contextValue?.subject || Global.localAppHandler.app_get_active_subject();
  const display_type = contextValue?.display_type || Global.localAppHandler.user.display_type;

  useEffect(() => {
    const fetchTrial = async () => {
      try {
        setDataReady(false);

        // Set active trial if trialId exists
        if (trialId) {
          await Global.localAppHandler.app_set_active_trial(trialId);
        }

        const new_trial = await Global.localAppHandler.app_get_trial({ include_metrics: true });
        setTrial(new_trial);
        setDataReady(true);
      } catch (error) {
        console.error("Error fetching trial:", error);
        navigate(-1);
      }
    };

    fetchTrial();
  }, [trialId, navigate]);

  if (!dataReady) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
        <div className="text-center">
          <div className="spinner-border mb-3" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="text-muted">Loading trial data...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="mx-2 mt-n10">
        {/* Use a row with no gutters so the columns are tighter */}
        <div className="row g-0">
          {/* Use col-auto for the arrow so its width fits its content */}
          <div className="col-auto align-items-center">
            <IoMdArrowRoundBack
              size={30}
              className="me-1 ms-4" // small margin to the right of the arrow
              style={{ cursor: "pointer" }}
              onClick={() => navigate(-1)}
            />
          </div>
          {/* The rest of the content */}
          <div className="col ms-5 me-10">
            <div className="card mb-4">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center">
                  <h4>{trial ? trial.trial_name : ""}</h4>
                </div>
                <TrialInformationTable trial={trial} />
              </div>
            </div>

            <div className="card mb-4">
              <div className="card-body">
                <MetricsTable metrics={trial && trial.trial_metrics ? trial.trial_metrics : null} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
